const API_URL = 'https://bbva-gateway.appspot.com';
const GPROFILE = '/gprofile/s/v2';

const ENDPOINTS_GPROFILE = {
  post: {
    session: () => `${API_URL}${GPROFILE}/session`
  }
};

export {
  ENDPOINTS_GPROFILE
};



// WEBPACK FOOTER //
// ./client/app/mobile/bbva-gapis/bbva-gapis.endpoints.js